import { useMemo, FC, memo } from 'react';
import styled from 'styled-components';

import { useAgoraEngine } from '@providers/AgoraEngineProvider';
import { useParticipantDataById } from '@redux/selectors/participants';
// import { useCurrentUser } from '@redux/selectors/users';
import {
  ParticipantPosition,
  ParticipantRole,
  ParticipantStatus,
  TeamType,
} from '@typings/participant';

import SkewedBackgroundAvatar from './SkewedBackgroundAvatar';
import NameContainer from './NameContainer';
import MuteButton from './MuteButton';

const Container = styled.div<{ $skewOffset: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  margin-left: -${({ $skewOffset }) => $skewOffset}px;
  margin-top: 8px;
  pointer-events: auto;
`;

const MuteButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 16px;
  z-index: 2;
`;

type Props = {
  participantId: string | null;
  side?: TeamType;
  size: {
    height: number;
    width: number;
  };
  emojisSequence?: string[];
  isSpeaking?: boolean;
  isRecord?: boolean;
  isStatusesShown?: boolean;
  isLikeDisabled?: boolean;
  isLiked?: boolean;
  likesCount?: number;
  onLike?: (isLiked: boolean) => void;
  onEmojiFinish?: () => void;
};

const SKEW_OFFSET = 0.32;

const RightSideParticipant: FC<Props> = ({
  participantId,
  side,
  size,
  // emojisSequence,
  isSpeaking,
  isRecord,
  isStatusesShown,
  isLikeDisabled,
  isLiked,
  likesCount,
  onLike,
  // onEmojiFinish,
}) => {
  // const [currentParticipantId, setCurrentParticipantId] = useState<
  //   string | null
  // >(null);
  const { height, width } = size;
  const participant = useParticipantDataById(participantId);
  // const profileData = useUserDataById(participant?.profileId);
  const { isHost } = useAgoraEngine();
  const isMuted = useMemo(
    () =>
      participant?.status &&
      (participant?.status === ParticipantStatus.ForceMuted ||
        participant?.status === ParticipantStatus.Muted),
    [participant?.status],
  );
  // const currentUser = useCurrentUser();
  // const isMe = useMemo(
  //   () => participant?.profileId === currentUser?.id,
  //   [participant?.profileId, currentUser?.id],
  // );

  if (!participantId) {
    return null;
  }
  return (
    <Container $skewOffset={Math.ceil(height * SKEW_OFFSET)}>
      <SkewedBackgroundAvatar
        position={ParticipantPosition.Right}
        userId={participant?.profileId}
        height={height}
        width={width}
        participantRole={
          participant?.role === ParticipantRole.Host ||
          participant?.role === ParticipantRole.CoHost
            ? participant?.role
            : undefined
        }
        isScaling={!isRecord && isSpeaking && !isMuted}
      />

      {isHost && participant?.role === ParticipantRole.Speaker && !isRecord && (
        <MuteButtonWrapper>
          <MuteButton
            participantId={participant.id}
            participantStatus={participant.status}
          />
        </MuteButtonWrapper>
      )}

      <NameContainer
        side={side}
        position={ParticipantPosition.Right}
        participantId={participantId}
        likesCount={likesCount}
        isLiked={isLiked}
        onLike={onLike}
        isLikeDisabled={isLikeDisabled}
        isStatusesShown={isStatusesShown}
        width={width + Math.ceil(height * 0.25)}
      />
    </Container>
  );
};

export default memo(RightSideParticipant);
